export default function filterInstructions(instructions, filterId, filter) {
  return !filter ? 
    // if filter is true, remove section with id that matches filterId
    instructions.filter(section => section.id !== filterId)
    // otherwise, leave instructions unchanged
    : instructions;
}